/**
 * Runtime environment selection — ONE build serves both projects.
 * Prod = the vekkle domains (backed by Firebase project `vekkle-prod`);
 * everything else (web.app dev sites, rkcconsultancy, localhost) = dev
 * (`autoverse-75b54`). Picking at runtime by hostname keeps deploys simple:
 * the same bundle goes to dev and prod hosting, no fileReplacements.
 */

import { Capacitor } from '@capacitor/core';

const PROD_HOSTS = new Set(['vekkle.com', 'app.vekkle.com', 'diecast.vekkle.com', 'vekkle.app', 'vekkle-prod.web.app', 'vekkle-app.web.app', 'vekkle-prod.firebaseapp.com']);

// Native shells serve from capacitor://localhost — hostname can't tell us the
// environment there, and a store build must never point at dev.
export const IS_NATIVE = Capacitor.isNativePlatform();

export const IS_PROD = IS_NATIVE || (typeof location !== 'undefined' && PROD_HOSTS.has(location.hostname));

export const IS_IOS_NATIVE = IS_NATIVE && Capacitor.getPlatform() === 'ios';

/** Native sign-in wiring (native always runs against vekkle-prod). */
export const APP_BUNDLE_ID = 'com.vekkle.app';
export const GOOGLE_WEB_CLIENT_ID = '358824905339-shblo167u7lns37fdmma4l73ln4pvpqb.apps.googleusercontent.com';

/**
 * In-app purchases (RevenueCat) on the native builds. Public SDK key — empty
 * keeps every store-purchase surface hidden. Entitlement id as configured in
 * RevenueCat; products: vekkle_premium_monthly / vekkle_premium_annual.
 */
export const REVENUECAT_IOS_KEY = 'appl_cokLJDLtfJKBIqiTjugZFahUAQS';
export const IAP_ENTITLEMENT = 'premium';
/** Consumable one-off checks (per registration); the premium-member full-check price is its own product. */
export const IAP_CHECK_PRODUCTS = {
  writeoff: 'vekkle_check_writeoff',
  full: 'vekkle_check_full',
  fullPremium: 'vekkle_check_full_premium',
} as const;

export const FIREBASE_CONFIG = IS_PROD
  ? {
      apiKey: 'AIzaSyBxe4ddKE8Ozm9huXb9iHccVQjFaIG-T4U',
      authDomain: location.hostname === 'localhost' ? 'vekkle-prod.firebaseapp.com' : location.hostname,
      projectId: 'vekkle-prod',
      storageBucket: 'vekkle-prod.firebasestorage.app',
      messagingSenderId: '358824905339',
      appId: '1:358824905339:web:616a2b9689fef391b730de',
      measurementId: 'G-PX8VBM2H75',
    }
  : {
      apiKey: 'AIzaSyDbzi8iO2mnijFX7bMvkJC717x9ltsdZQ8',
      authDomain: typeof location !== 'undefined' && location.hostname !== 'localhost' ? location.hostname : 'autoverse-75b54.firebaseapp.com',
      projectId: 'autoverse-75b54',
      storageBucket: 'autoverse-75b54.firebasestorage.app',
      messagingSenderId: '332038455073',
      appId: '1:332038455073:web:f9af1af0ad7479c51a0860',
      measurementId: 'G-H2G1118MSH',
    };

export const FUNCTIONS_BASE = IS_PROD
  ? 'https://europe-west2-vekkle-prod.cloudfunctions.net'
  : 'https://europe-west2-autoverse-75b54.cloudfunctions.net';

export const APPCHECK_SITE_KEY = IS_PROD
  ? '6Lf2IJotAAAAAJlP3hsUr5ohdzAm-Pely0eLx3GW'
  : '6Lcb1JEtAAAAAIMk3W6sk4_TaB3Pd_gs5kAszPiK';

/** Where an invite points people. Swap for the store listing once it exists. */
export const APP_INVITE_URL = 'https://vekkle.com';
